// Progress bar
customElements.define(
	'progressbar-rewards',
	class ProgressBarRewards extends HTMLElement {
		constructor() {
			super();

			let selectors = {
				progressSettings: '[data-progressbar-rewards-settings]',
				progressSettingsData: 'progressbarRewardsSettings',
				progressCurrentMessage: '[data-progressbar-rewards--current-message]',
				progressNextMessage: '[data-progressbar-rewards--next-message]',
				progressCurrency: '[data-progressbar-currency]',
				progressImage: '[data-progressbar-rewards--image]',
				progressBarContainer: '[data-progressbar-rewards--progress-bar-container]',
				progressBar: '[data-progressbar-rewards--progress-bar]',
				progressThreshold: '[data-progressbar-rewards--threshold]',
				progressThresholdMarker: '[data-progressbar-rewards--threshold-marker]',
			};

			this.selectors = selectors;
			
			this.lastOperationTime = 0;

			this.init();

			this.processing = false;

			document.addEventListener('processingChangeRewards', (event) => {
				this.processing = event.detail.processing;
			});
		}

		getCookieItemReward(name) {
			let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}

		setCookieItemReward(name, value, days) {
			let d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
		}

		deleteCookieItemReward(name) {
			this.setCookieItemReward(name, '', -1);
		}

		async init() {
			const currentTime = Date.now();
			if (currentTime - this.lastOperationTime < 3000) {
				return;
			}
			
			let progressNextMessage = this.querySelector(this.selectors.progressNextMessage);
			const progressSettingsElement = this.querySelector(this.selectors.progressSettings);

			if (progressSettingsElement !== null && progressSettingsElement !== undefined) {
				// === Get all elements

				const packSettingsData = JSON.parse(
					progressSettingsElement.dataset[this.selectors.progressSettingsData],
				);

				const progressBar = this.querySelector(this.selectors.progressBar);
				let progressThresholds = this.querySelectorAll(this.selectors.progressThreshold);

				let lastStepReach = false;

				const cart = await cartManager.getCart();
				let queue = Promise.resolve();

				// === Cart total price

				let cartTotalPrice = cart.total_price;

				// === Get steps info

				// - Get current and next step
				let currentStep = null;
				let nextStep = null;
				let nextThreshold = null;
				for (let index = 0; index < packSettingsData.steps.length; index++) {
					if (cartTotalPrice >= parseInt(packSettingsData.steps[index].threshold) - 1) {
						currentStep = packSettingsData.steps[index];
						nextStep = packSettingsData.steps[index + 1];
					}
				}

				// - None step reach
				if (currentStep == null && nextStep == null) {
					nextStep = packSettingsData.steps[0];
				}

				// - Last step reach
				if (currentStep !== null && nextStep == null) {
					lastStepReach = true;
				}

				//set markers
				let progressThresholdMarkers = this.querySelectorAll(
					this.selectors.progressThresholdMarker,
				);
				let progressBarContainer = this.querySelector(this.selectors.progressBarContainer);
				if (progressThresholdMarkers != null) {
					var markerWidth = progressBarContainer.offsetWidth / progressThresholdMarkers.length;
					var markerPosition = markerWidth / 4;
					progressThresholdMarkers.forEach(function callback(marker, index) {
						marker.style.left = markerWidth * index + markerPosition * (index + 1) + 'px';
					});
				}

				if (!lastStepReach) {
					const currency = this.querySelector(this.selectors.progressCurrency).getAttribute(
						'data-progressbar-currency',
					);
					var leftBeforeThreshold =
						'<span class="scz-cart-rewards__price-left">' +
						Shopify.formatMoney(
							parseInt(nextStep.threshold) - cart.total_price,
							'amount_with_comma_separator',
						) +
						currency +
						'</span>';
					var nextMessage = nextStep.before_message.replace('##left##', leftBeforeThreshold);
					nextThreshold = parseInt(nextStep.threshold);
				} else {
					var nextMessage = currentStep.after_message;
					nextThreshold = parseInt(currentStep.threshold);
				}

				progressNextMessage.innerHTML = nextMessage.replace('##%##', "'");

				if (lastStepReach) {
					progressBar.style.width = '100%';
				} else {
					// - Default: Percentage from 0€
					let percentage = (parseFloat(cartTotalPrice) * 100) / nextThreshold;
					const nextMarker = this.querySelector(
						'[data-progressbar-rewards--threshold-marker="' + nextThreshold.toString() + '"]',
					);

					let currentMarker = null;
					if (currentStep !== null) {
						currentMarker = this.querySelector(
							'[data-progressbar-rewards--threshold-marker="' +
								parseInt(currentStep.threshold).toString() +
								'"]',
						);
					}

					if (nextMarker !== null) {
						let nextMarkerPosition = null;
						if (currentStep !== null && currentStep.threshold != 0) {
							nextMarkerPosition = parseFloat(nextMarker.offsetLeft);
							const currentMarkerPosition = parseFloat(currentMarker.offsetLeft);

							percentage =
								((parseFloat(cartTotalPrice) - parseInt(currentStep.threshold)) * 100) /
								(nextThreshold - parseInt(currentStep.threshold));

							const finalWidth =
								currentMarkerPosition +
								percentage * ((nextMarkerPosition - currentMarkerPosition) / 100);
							progressBar.style.width = finalWidth + 'px';
						} else {
							nextMarkerPosition = parseFloat(nextMarker.offsetLeft);
							const finalWidth = (percentage * nextMarkerPosition) / 100;
							progressBar.style.width = finalWidth + 'px';
						}
					} else {
						progressBar.style.width = percentage + '%';
					}
				}

				if (progressThresholds !== null) {
					progressThresholds.forEach(function callback(threshold, index) {
						if (threshold.dataset['progressbarRewards-Threshold'] <= cartTotalPrice) {
							threshold.classList.add('active');
						} else {
							threshold.classList.remove('active');
						}
					});
				}

				// === Rewards products
				if (
					packSettingsData?.steps &&
					packSettingsData?.steps?.length > 0 &&
					this.processing === false
				) {
					let items = [];

					packSettingsData.steps.forEach(async (step) => {
						if (step.type && step.type === 'product') {
							if (cartTotalPrice >= parseInt(step.threshold) - 1) {
								// - Check if product already added
								let productAlreadyAdded = false;
								for (let index = 0; index < cart.items.length; index++) {
									if (cart.items[index].properties !== null) {
										if (cart.items[index].properties['_is_reward'] === true) {
											if (step.id == cart.items[index].properties['_reward_id']) {
												productAlreadyAdded = true;
											}
										}
									}
								}

								// - Check reward is adding
								let rewardsIsAdding = [];
								let productAlreadyIsAdding = false;
								let productToExclude = false;
								if (this.getCookieItemReward('rewardsIsAdding') !== null) {
									rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
								}
								if (rewardsIsAdding.length > 0) {
									rewardsIsAdding.forEach((rewardIsAdding) => {
										if (rewardIsAdding.id === step.id) {
											productAlreadyIsAdding = true;
										}
									});
								}

								if (
									cartManager.itemRewardsToExclude &&
									cartManager.itemRewardsToExclude.length > 0 &&
									cartManager.itemRewardsToExclude.includes(step.id)
								) {
									productToExclude = true;
								}

								// - If product not added: add product

								if (
									productAlreadyAdded === false &&
									productAlreadyIsAdding === false &&
									productToExclude == false
								) {
									// - Add cookie is adding
									rewardsIsAdding.push({
										variant_id: step.variant_id,
										threshold: step.threshold,
										id: step.id,
									});
									this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

									// - Set items to add
									if (step.type === 'product') {
										items.push({
											id: step.variant_id,
											quantity: 1,
											properties: {
												_is_reward: true,
												_reward_id: step.id,
												_reward_threshold: step.threshold,
											},
										});
									}
								}
							}
						}
					});

					// === setcookieNull

					// === Add items
					if (items.length > 0) {
						this.lastOperationTime = Date.now();
						
						queue = queue.then(async () => {
							const rewardAddedResult = await this.addItems(items);
							if (rewardAddedResult === true) {
								// - Get cookie 'rewardsAdded'
								let rewardsAdded = [];
								if (this.getCookieItemReward('rewardsAdded') !== null) {
									rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
								}

								// - Get cookie 'rewardsIsAdding'
								let rewardsIsAdding = [];
								if (this.getCookieItemReward('rewardsIsAdding') !== null) {
									rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
								}

								items.forEach((item) => {
									// - Add reward in cookie 'rewardsAdded'
									let itemIsAlreadyInCookie = false;
									if (rewardsAdded.length > 0) {
										rewardsAdded.forEach((rewardAdded) => {
											if (rewardAdded.id === item.properties['_reward_id']) {
												itemIsAlreadyInCookie = true;
											}
										});
									}
									if (itemIsAlreadyInCookie === false) {
										rewardsAdded.push({
											variant_id: item.id,
											threshold: item.properties['_reward_threshold'],
											id: item.properties['_reward_id'],
										});
									}

									// - Remove reward in cookie 'rewardsIsAdding'
									if (rewardsIsAdding.length > 0) {
										for (let index = 0; index < rewardsIsAdding.length; index++) {
											if (rewardsIsAdding[index].id == item.properties['_reward_id']) {
												rewardsIsAdding.splice(index, 1);
											}
										}
									}
								});

								this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
								this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);
							}
						});
					}
				}

				// === Remove items: If reward product added and his threshold > cartTotalPrice: remove this reward product
				if (cart.items && cart.items.length > 0) {
					let itemsToRemove = {};

					for (let index = 0; index < cart.items.length; index++) {
						if (cart.items[index].properties !== null) {
							if (cart.items[index].properties['_is_reward'] === true) {
								if (parseInt(cart.items[index].properties['_reward_threshold']) > (cartTotalPrice +
									5)) {
									// - Check reward is removing
									let rewardsIsRemoving = [];
									let productAlreadyIsRemoving = false;
									if (this.getCookieItemReward('rewardsIsRemoving') !== null) {
										rewardsIsRemoving = JSON.parse(this.getCookieItemReward('rewardsIsRemoving'));
									}
									if (rewardsIsRemoving.length > 0) {
										rewardsIsRemoving.forEach((rewardIsRemoving) => {
											if (rewardIsRemoving.id === cart.items[index].properties['_reward_id']) {
												productAlreadyIsRemoving = true;
											}
										});
									}

									if (productAlreadyIsRemoving === false) {
										// - Add cookie is removing
										rewardsIsRemoving.push({
											variant_id: cart.items[index].variant_id,
											threshold: cart.items[index].properties['_reward_threshold'],
											id: cart.items[index].properties['_reward_id'],
										});
										this.setCookieItemReward(
											'rewardsIsRemoving',
											JSON.stringify(rewardsIsRemoving),
											3,
										);

										// - Set items to remove
										itemsToRemove[cart.items[index].variant_id] = 0;
									}
								}
							}
						}
					}

					// Remove items
					if (Object.keys(itemsToRemove).length > 0) {
						this.lastOperationTime = Date.now();
						
						queue = queue.then(async () => {
							const rewardsRemoved = await this.removeItems(itemsToRemove);
							if (rewardsRemoved === true) {
								// - Get cookie 'rewardsAdded'
								let rewardsAdded = [];
								if (this.getCookieItemReward('rewardsAdded') !== null) {
									rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
								}

								// - Get cookie 'rewardsIsRemoving'
								let rewardsIsRemoving = [];
								if (this.getCookieItemReward('rewardsIsRemoving') !== null) {
									rewardsIsRemoving = JSON.parse(this.getCookieItemReward('rewardsIsRemoving'));
								}

								for (const [key] of Object.entries(itemsToRemove)) {
									// - Remove reward in cookie 'rewardsAdded'
									if (rewardsAdded.length > 0) {
										for (let index = 0; index < rewardsAdded.length; index++) {
											if (rewardsAdded[index].variant_id == key.toString()) {
												rewardsAdded.splice(index, 1);
											}
										}
									}

									// - Remove reward in cookie 'rewardsIsRemoving'
									if (rewardsIsRemoving.length > 0) {
										for (let index = 0; index < rewardsIsRemoving.length; index++) {
											if (rewardsIsRemoving[index].variant_id == key.toString()) {
												rewardsIsRemoving.splice(index, 1);
											}
										}
									}
								}

								this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
								this.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);
							}
						});
					}
				}

				// === Queue error
				queue.catch((e) => {
					console.error(e);
				});

				// === [Security] If cartTotalPrice == 0: delete cookie 'rewardsAdded'
				if (cartTotalPrice == 0) {
					this.deleteCookieItemReward('rewardsAdded');
					this.deleteCookieItemReward('rewardsIsAdding');
					this.deleteCookieItemReward('rewardsIsRemoving');
				}
			}
		}

		reverseNodeList(nodeList) {
			const array = Array.from(nodeList);
			const reversedArray = array.reverse();
			return reversedArray;
		}

		async addItems(items) {
			const config = fetchConfig('javascript');
			config.headers['Content-Type'];
			const itemsData = {
				items: items,
			};
			config.body = JSON.stringify(itemsData);

			const result = await fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						return false;
					}

					return true;
				})
				.catch((e) => {
					const allLoadingOverlay = this.querySelectorAll('.loading-overlay');
					if (allLoadingOverlay.length > 0) {
						allLoadingOverlay.forEach((overlay) => overlay.classList.add('hidden'));
					}
					console.error(e);
				});

			return result;
		}

		async removeItems(items) {
			const config = fetchConfig('javascript');
			config.headers['Content-Type'];
			config.body = JSON.stringify({
				updates: items,
			});

			const result = await fetch('/cart/update?drawer-item-reward', config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						return false;
					}

					return true;
				})
				.catch((e) => {
					console.error(e);
				});

			return result;
		}
	},
);

customElements.define(
	'drawer-item-reward',
	class DrawerItemReward extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				updateRewardTrigger: '[data-item-reward-update]',
				updateRewardKey: 'itemRewardUpdateKey',
				updateRewardPanel: '[data-item-reward-panel]',
				updateRewardPanelClose: '[data-item-reward-panel-close]',
				updateRewardPanelItem: '[data-item-reward-panel-item]',
				updateRewardPanelItemId: 'itemRewardPanelItemVariant',
				updateRewardPanelChange: '[data-item-reward-panel-change]',
			};

			this.updateRewardTrigger = this.querySelector(this.selectors.updateRewardTrigger);
			this.updateRewardKey = this.updateRewardTrigger.dataset[this.selectors.updateRewardKey];
			this.updateRewardPanel = this.querySelector(this.selectors.updateRewardPanel);
			this.updateRewardPanelClose = this.querySelector(this.selectors.updateRewardPanelClose);
			this.updateRewardPanelItems = this.querySelectorAll(this.selectors.updateRewardPanelItem);
			this.updateRewardPanelChange = this.querySelector(this.selectors.updateRewardPanelChange);

			this.isProcessing = false; // Variable d'état pour éviter le spam
			this.selectedItem = null; // Stocke l'élément actuellement sélectionné

			this.init();
		}

		async init() {
			this.setupEventListeners();
		}

		setupEventListeners() {
			this.updateRewardTrigger.addEventListener('click', () => this.open());
			this.updateRewardPanelClose.addEventListener('click', () => this.close());

			this.updateRewardPanelItems.forEach((item) => {
				item.addEventListener('click', () => this.handleItemSelection(item));
			});

			this.updateRewardPanelChange.addEventListener('click', async () => {
				if (this.isProcessing || !this.selectedItem) return;
				this.isProcessing = true;
				this.updateRewardPanelChange.setAttribute('disabled', '');

				try {
					await this.processRewards();
				} catch (error) {
					console.error('Error processing rewards:', error);
				} finally {
					this.isProcessing = false;
					this.updateRewardPanelChange.removeAttribute('disabled');
				}
			});
		}

		handleItemSelection(item) {
			if (this.isProcessing) return;

			this.updateRewardPanelItems.forEach((i) => {
				i.classList.remove('active');
			});

			item.classList.add('active');
			this.selectedItem = item; // Enregistrez l'élément sélectionné

			// Simule le clic sur le bouton de changement, mais seulement si ce n'est pas déjà en cours de traitement
			if (!this.isProcessing) {
				this.updateRewardPanelChange.click();
			}
		}

		async processRewards() {
			const cart = await cartManager.getCart();
			const variantId = this.selectedItem.dataset[this.selectors.updateRewardPanelItemId];
			let properties = {};

			const cartItem = cart.items.find((i) => i.key === this.updateRewardKey);
			if (cartItem) {
				properties = cartItem.properties;
			}

			if (variantId === 'null') {
				let rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsIsAdding') || '[]');
				rewardsAdded.push({
					variant_id: variantId,
					threshold: properties['_reward_threshold'],
					id: properties['_reward_id'],
				});
				this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsAdded), 3);
			}

			document.dispatchEvent(
				new CustomEvent('processingChangeRewards', { bubbles: true, detail: { processing: true } }),
			);

			await this.updateItemById(this.updateRewardKey, 0);
			await this.addItem(variantId, 1, properties);
		}

		open() {
			this.updateRewardPanel.classList.add('active');
		}

		close() {
			this.updateRewardPanel.classList.add('close');
			this.updateRewardPanel.classList.remove('active');
			setTimeout(() => this.updateRewardPanel.classList.remove('close'), 1000);
		}

		setCookieItemReward(name, value, days) {
			let d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`;
		}

		getCookieItemReward(name) {
			const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
			return match ? match[2] : null;
		}

		async addItem(variantId, quantity, properties) {
			try {
				console.log(
					JSON.stringify({
						id: variantId,
						quantity: quantity,
						properties: properties,
					}),
				);
				await fetch('/cart/add.js?drawer-item-reward', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify({
						id: variantId,
						quantity: quantity,
						properties: properties,
					}),
				});
				document.dispatchEvent(
					new CustomEvent('processingChangeRewards', {
						bubbles: true,
						detail: { processing: false },
					}),
				);
			} catch (error) {
				console.error('Error adding item:', error);
			}
		}

		async updateItem(data) {
			try {
				await fetch('/cart/change.js?drawer-item-reward', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
					},
					body: JSON.stringify(data),
				});
			} catch (error) {
				console.error('Error updating item:', error);
			}
		}

		updateItemById(lineItemId, newQuantity, newProperties = {}) {
			return this.updateItem({
				id: lineItemId,
				quantity: newQuantity,
				properties: newProperties,
			});
		}
	},
);
